import React, { useEffect, useState } from 'react';
import api from '../../api/axios';
import { FiSearch } from 'react-icons/fi';

const STATUS_STYLES: Record<string, { bg: string; color: string }> = {
  paid: { bg: '#10b98118', color: '#10b981' },
  pending: { bg: '#f59e0b18', color: '#f59e0b' },
  failed: { bg: '#ef444418', color: '#ef4444' },
};

export default function AdminPayments() {
  const [data, setData] = useState<any>(null);
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [page, setPage] = useState(1);

  const load = (p = 1, q = '', status = '') => {
    const params = new URLSearchParams({ page: String(p) });
    if (q) params.set('search', q);
    if (status) params.set('status', status);
    api.get(`/admin/payments?${params}`).then((res) => setData(res.data));
  };

  useEffect(() => { load(); }, []);

  const handleSearch = () => { setPage(1); load(1, search, statusFilter); };
  const handleStatus = (s: string) => { setStatusFilter(s); setPage(1); load(1, search, s); };

  if (!data) return <div className="empty-state"><p>Loading...</p></div>;

  return (
    <div>
      <h1 style={{ margin: '0 0 20px', fontSize: 22, fontWeight: 700 }}>Payments & Transactions</h1>

      <div className="admin-search">
        <input
          placeholder="Search by transaction ID, plan, or store name..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
        />
        <select
          value={statusFilter}
          onChange={(e) => handleStatus(e.target.value)}
          style={{ padding: '10px 14px', border: '1px solid var(--gray-200)', borderRadius: 'var(--radius)', fontSize: 14 }}
        >
          <option value="">All Status</option>
          <option value="paid">Paid</option>
          <option value="pending">Pending</option>
          <option value="failed">Failed</option>
        </select>
        <button className="btn btn-primary" onClick={handleSearch}><FiSearch /></button>
      </div>

      <div className="card">
        <div className="data-table">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Store</th>
                <th>Plan</th>
                <th>Amount</th>
                <th>Method</th>
                <th>Transaction ID</th>
                <th>Status</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {data.data.map((p: any) => {
                const st = STATUS_STYLES[p.payment_status] || { bg: '#94a3b818', color: '#94a3b8' };
                return (
                  <tr key={p.id}>
                    <td>{p.id}</td>
                    <td>
                      <div style={{ fontSize: 13 }}><strong>{p.store?.name || '-'}</strong></div>
                      <div style={{ fontSize: 11, color: 'var(--gray-400)' }}>{p.store?.user?.email}</div>
                    </td>
                    <td style={{ textTransform: 'capitalize', fontWeight: 600 }}>{p.plan}</td>
                    <td>{Number(p.amount).toFixed(3)} {p.currency}</td>
                    <td style={{ textTransform: 'uppercase', fontSize: 12, fontWeight: 600 }}>{p.payment_method}</td>
                    <td style={{ fontFamily: 'monospace', fontSize: 12 }}>{p.transaction_id || '-'}</td>
                    <td>
                      <span style={{
                        padding: '3px 10px', borderRadius: 12, fontSize: 12, fontWeight: 600,
                        background: st.bg, color: st.color, textTransform: 'capitalize',
                      }}>
                        {p.payment_status}
                      </span>
                    </td>
                    <td style={{ fontSize: 13 }}>{new Date(p.created_at).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</td>
                  </tr>
                );
              })}
              {data.data.length === 0 && (
                <tr><td colSpan={8} style={{ textAlign: 'center', padding: 40, color: 'var(--gray-400)' }}>No payments found</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {data.last_page > 1 && (
        <div style={{ display: 'flex', gap: 8, marginTop: 16, justifyContent: 'center' }}>
          {Array.from({ length: data.last_page }, (_, i) => i + 1).map((p) => (
            <button
              key={p}
              className={`btn ${p === data.current_page ? 'btn-primary' : 'btn-outline'}`}
              style={{ minWidth: 36, padding: '6px 10px', fontSize: 13 }}
              onClick={() => { setPage(p); load(p, search, statusFilter); }}
            >
              {p}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
